import styled from "styled-components";
import TextareaAutosize from "react-textarea-autosize";

export const Style = styled.div`
  display: flex;
  border: 1px solid #ccc;
  align-items: center;
  min-height: 40px;
  padding: 0 8px;
  &.ant-input-disabled * {
    cursor: not-allowed;
  }
  .text-item {
    line-height: 15px;
    padding-bottom: 3px;
    margin: 0;
    font-family: "Noto Sans JP";
    overflow: hidden;
    white-space: break-spaces;
    overflow-wrap: break-word;
  }
  .ant-form-item {
    height: 100%;
  }
`;
export const StyledInputCell = styled(TextareaAutosize)`
  border: none;
  overflow: hidden;
  line-height: 1;
  width: 100%;
  outline: none;
  color: #222;
  background: transparent;
  box-shadow: none;
  min-height: 22px;
  padding: 4px;
`;
